export default "__VITE_ASSET__d0e6e572__"